"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicTextAreaField = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
var _DeprecatedDynamicComponent = _interopRequireDefault(require("../../go/components/dynamic/DeprecatedDynamicComponent"));
var _TextAreaField = _interopRequireDefault(require("../../go/components/common/form/TextAreaField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DynamicTextAreaField = /*#__PURE__*/function (_DynamicComponent) {
  _inherits(DynamicTextAreaField, _DynamicComponent);
  var _super = _createSuper(DynamicTextAreaField);
  function DynamicTextAreaField() {
    var _this;
    _classCallCheck(this, DynamicTextAreaField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.handleChange = function (e, _ref) {
      var value = _ref.value;
      _this.setState(_defineProperty({}, _this.props.pathToBeUsed, value));
    };
    _this.handleBlur = function () {
      var _this$props = _this.props,
        entityType = _this$props.entityType,
        entityDataPath = _this$props.entityDataPath,
        validationId = _this$props.validationId,
        pathToBeUsed = _this$props.pathToBeUsed,
        saveSessionOnly = _this$props.saveSessionOnly;
      if (entityDataPath !== undefined) {
        if (saveSessionOnly === true) {
          _this.props.saveEntitySessionData(entityDataPath, _this.state[pathToBeUsed], validationId || entityDataPath);
        } else {
          _this.props.saveEntityData(entityDataPath, entityType, _this.state[pathToBeUsed], validationId || entityDataPath);
        }
      } else {
        _this.save();
      }
      _this.validateField(pathToBeUsed);
    };
    _this.render = function () {
      var _this$props2 = _this.props,
        id = _this$props2.id,
        guidance = _this$props2.guidance,
        title = _this$props2.title,
        hintText = _this$props2.hintText,
        optional = _this$props2.optional,
        maxLength = _this$props2.maxLength,
        formOptions = _this$props2.formOptions,
        pathToBeUsed = _this$props2.pathToBeUsed,
        isHidden = _this$props2.isHidden,
        rows = _this$props2.rows,
        validationErrors = _this$props2.validationErrors,
        validationDirtyMap = _this$props2.validationDirtyMap,
        className = _this$props2.className,
        ariaLabelledBy = _this$props2.ariaLabelledBy;
      var validationErrorsArray = _lodash.default.isEmpty(validationErrors) || _lodash.default.isArray(validationErrors) ? validationErrors : [validationErrors];
      var firstError = _lodash.default.find(validationErrorsArray, function (err) {
        return !err.isValid;
      }) || false;
      var errorMessage = firstError ? firstError.message : false;
      var displayError = firstError && validationDirtyMap.dirty || _this.displayError(pathToBeUsed);
      var errorMessages = errorMessage || _this.errorMessages(pathToBeUsed);
      if (isHidden) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: className ? className : ''
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "questionText"
      }, (0, _reactHtmlParser.default)(guidance)), /*#__PURE__*/_react.default.createElement(_TextAreaField.default, {
        value: _this.state[pathToBeUsed],
        label: title,
        id: id || pathToBeUsed,
        optional: optional,
        name: pathToBeUsed,
        hintText: hintText,
        maxLength: maxLength,
        displayError: displayError,
        handleChange: _this.handleChange,
        handleBlur: _this.handleBlur,
        errorMessages: errorMessages,
        disabled: formOptions && formOptions.disabled,
        rows: rows || 3,
        ariaLabelledBy: ariaLabelledBy || id
      })));
    };
    return _this;
  }
  _createClass(DynamicTextAreaField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.refreshData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.refreshData(prevProps);
    }
  }, {
    key: "refreshData",
    value: function refreshData(prevProps) {
      var _this$props3 = this.props,
        isHidden = _this$props3.isHidden,
        data = _this$props3.data,
        pathToBeUsed = _this$props3.pathToBeUsed,
        entityDataPath = _this$props3.entityDataPath,
        entityType = _this$props3.entityType,
        validationId = _this$props3.validationId,
        clearEntityData = _this$props3.clearEntityData;
      if (!isHidden && !_lodash.default.isEqual(_lodash.default.get(prevProps, 'data'), data)) {
        this.setState(_defineProperty({}, pathToBeUsed, data));
      } else if (isHidden && this.state[pathToBeUsed] !== undefined) {
        this.setState(_defineProperty({}, pathToBeUsed, undefined), function () {
          return clearEntityData(entityDataPath, entityType, validationId);
        });
      }
    }
  }]);
  return DynamicTextAreaField;
}(_DeprecatedDynamicComponent.default);
exports.DynamicTextAreaField = DynamicTextAreaField;